import { CommonModule } from '@angular/common';
import { Component, HostBinding, input, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { MovieLoadingComponent, MovieDetailSkeletonComponent } from '@usheru-hff/ui/movie-detail-page';
import { Movie } from '@usheru-hff/shared/domain';
import { LoadingIndicatorComponent } from '@usheru-hff/shared/ui-loading-indicator';
import { SharedUiPictureModule } from '@usheru-hff/shared/ui-picture';
import { SharedUiStreamingLogoFallbackModule } from '@usheru-hff/shared/ui-streaming-logo-fallback';
import { SharedUtilsModule } from '@usheru-hff/shared/utils';
import { SharedUtilsImageModule } from '@usheru-hff/shared/utils-image';

@Component({
  selector: 'ush-assets-locker-link',
  styleUrls: ['./access-locker-link.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    SharedUiPictureModule,
    FontAwesomeModule,

    SharedUtilsImageModule,
    SharedUtilsModule,
    SharedUiStreamingLogoFallbackModule,
    LoadingIndicatorComponent,
    MovieDetailSkeletonComponent
  ],
  template: `
    <div class="access-locker-link__wrapper">
      @if (isLoadingData()) {
        @if (!hideLabel) {
          <ush-movie-detail-skeleton width="12rem" height="1.5rem"></ush-movie-detail-skeleton>
        }
        <ush-movie-detail-skeleton width="11rem" height="3rem" radius="999px"></ush-movie-detail-skeleton>
      } @else {
        @if (!hideLabel) {
          <div class="access-locker-link__header title" [attr.data-translate]="resolvedLabelKey">{{ label }}</div>
        }

        @if (loadingTranslation()) {
          <span class="access-locker-link__button loading">
            <ush-loading-indicator [style.height]="'100%'" [aligning]="'absolute-center'"> </ush-loading-indicator
          ></span>
        } @else {
          <a class="access-locker-link__button" [routerLink]="routerLink" [attr.data-translate]="resolvedLabelKey">
            {{ labelButton }}
          </a>
        }
      }
    </div>
  `
})
export class AssetsLockerLinkComponent implements MovieLoadingComponent {
  readonly movie = input<Movie | null>(null);
  @Input() hideLabel = false;
  @Input() label = $localize`:@@assets-locker.available:Available assets`;
  @Input() labelButton = $localize`:@@assets-locker.download:Download assets`;
  @Input() labelKey = 'assets-locker.available';
  @HostBinding('class')
  @Input({ required: false })
  classes: string;
  readonly isLoadingData = input(false);

  loadingTranslation = input<boolean>(false);
  get resolvedLabelKey(): string {
    if (this.labelKey) return this.labelKey;
    return this.hideLabel ? 'assets-locker.available' : 'assets-locker.download';
  }

  get routerLink() {
    return `/movie/${this.movie()?.friendlyUrl}/press-kit`;
  }
}
